export default {
  title: 'Liste de recruteurs avec une disponibilité basse',
  subTitle: 'Ceci est une liste de vos recruteurs avec une disponibilité faible ou limitée.',
  tooltipModalHint: 'Cliquez ici pour voir une liste de recruteurs avec une faible disponibilité',
  modalDescription: "{{count}} recruteurs n'ont pas assez de disponibilité pour passer des candidats en entrevue.",
  mySchedule: 'Voir mes disponibilités',
  positionsImpacted: 'Voir les postes affectés',
};
